import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { AddressService } from './address.service';
import { BudgetService } from './budget.service';
import { Order } from '../models/order.model';
import { Product } from '../models/product.model';
import { OrderItem } from '../models/order-item.model';
import { Address } from '../models/address.model';
import { computeAvailableAddresses } from '../shared/helpers';
import { isEmptyArray } from '../shared/utils';
import { OrderItemDelivery } from '../models/order-item-delivery.model';

@Injectable()
export class HelperService {
  constructor(
    private authService: AuthService,
    private addressService: AddressService,
    private budgetService: BudgetService
  ) {}

  public canOrder(order: Order): boolean {
    return this.authService.canEditOrder(order);
  }

  private  setDefaultDeliveries(order: Order, orderItem: OrderItem): OrderItem {

    const isDecisionPointOrder = (o: Order): boolean =>  {
      return o?.isDecisionPoint || false;
    }

    if (isDecisionPointOrder(order) ||
      (!isEmptyArray(orderItem.deliveries) && orderItem.deliveries[0].addressDefined)) {
      return orderItem;
    }

    const product = orderItem.product;

    // clean up existing deliveries
    orderItem.deliveries = [];

    const userRoles = {
      canOrder: this.authService.canOrder,
      isEmployee: this.authService.isEmployee,
    };

    const availableAddresses = computeAvailableAddresses(
      this.addressService.addresses,
      order,
      orderItem
    );

    const addresses = product.isInternationalShipmentAllowed
      ? availableAddresses
      : availableAddresses.filter((a) => a.isInternational !== true);


    // for delivery initializing, create new delivery for  each  sku
    for (const sku of product.skus) {
      const delivery = new OrderItemDelivery({
        type: 'SHIPPING',
        method: product.firstAvailableShippingMethod,
        quantity: 0,
        data: {},
        sku_id: sku.id,
      });

      if (order.isWSLR) {
        // set default WLS address
        const entityAddress = Address.fromEntityLocation(
          order.entity.getDefaultShippingLocation()
        );
        if (entityAddress) {
          delivery.setAddress(
            entityAddress,
            this.authService.user,
            order.isCustom,
            userRoles
          );
        }
      } else {
        // set user's default address
        if (!isEmptyArray(addresses)) {
          delivery.setAddress(
            addresses[0],
            this.authService.user,
            order.isCustom,
            userRoles
          );
        }
      }

      orderItem.deliveries.push(delivery);
    }

    return orderItem;
  }

  public setupOrderItem(order: Order, product: Product): OrderItem {
    if (!order || !product) {
      return null;
    }

    let orderItem = order.getItemForProduct(product, null);

    if (this.canOrder(order)) {

      orderItem = this.setDefaultDeliveries(order, orderItem);
      // const userRoles = {
      //   canOrder: true,
      //   isEmployee: this.authService.isEmployee,
      // };
      // // Select first address
      // if (
      //   orderItem.deliveries.length > 0 &&
      //   !orderItem.deliveries[0].street_1
      // ) {
      //   if (order.isWSLR) {
      //     // set default WLS address
      //     const entityAddress = Address.fromEntityLocation(
      //       order.entity.getDefaultShippingLocation()
      //     );
      //     if (entityAddress) {
      //       orderItem.deliveries[0].setAddress(
      //         entityAddress,
      //         this.authService.user,
      //         order.isCustom,
      //         userRoles
      //       );
      //     }
      //   } else {
      //     // set user's default address
      //     const availableAddresses = computeAvailableAddresses(
      //       this.addressService.addresses,
      //       order,
      //       orderItem
      //     );
      //     if (!isEmptyArray(availableAddresses)) {
      //       orderItem.deliveries[0].setAddress(
      //         availableAddresses[0],
      //         this.authService.user,
      //         order.isCustom,
      //         userRoles
      //       );
      //     }
      //   }
      // }
      this.findBudget(orderItem);
    }

    return orderItem;
  }

  private findBudget(orderItem: OrderItem) {
    const budgetId = orderItem?.financials_total?.budget_id;
    if (budgetId === -1) {
      orderItem.budgetItem = this.budgetService.emptyBudget;
    } else if (orderItem.financials_total.budget_id > 0) {
      orderItem.budgetItem = this.budgetService.budgets.find(
        (b) => b.id === orderItem.financials_total.budget_id
      );
    } else {
      const hardLimitBudget = this.budgetService.getHardlimitBudgetForProduct(
        orderItem.product
      );
      if (hardLimitBudget) {
        orderItem.financials_total.budget_id = hardLimitBudget.id;
        orderItem.budgetItem = hardLimitBudget;
      }
    }
  }
}
